import { rgba } from '@vimeo/bokeh-utils';
import { blue, slate } from '../tokens/colors.js';

const Tabs = {
  baseStyle: {
    tab: {
      background: "transparent",
      padding: 0,
      lineHeight: "inherit",
      color: "inherit",
      fontWeight: "bold",
      height: "2.5rem",
      minWidth: "5rem",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "0.5rem",
      cursor: "pointer",
      width: "100%"
    },
    tabpanel: {
      marginTop: "0.75rem"
    },
    tablist: {
      position: "relative",
      borderBottomWidth: "2px",
      borderColor: rgba("black", 0.1),
      padding: "0.334rem 0",
      _dark: {
        borderColor: "grayscale.700"
      },
      ".chakra-tabs__tab-indicator": {
        position: "absolute",
        top: "calc(100%)",
        height: "0.125rem",
        bg: "blue.500",
        borderRadius: "sm",
        zIndex: 1
      }
    }
  },
  variants: {
    inlay: {
      root: {
        ".chakra-tabs__tab-indicator": {
          display: "none"
        }
      },
      tab: {
        margin: "0 0.334rem",
        transition: "all .2s ease-in-out",
        _hover: {
          backgroundColor: rgba("black", 0.1),
          color: "slate.800"
        },
        _selected: {
          backgroundColor: "white",
          boxShadow: `0 3px 6px 0 ${rgba("black", 0.125)}`,
          color: "black"
        },
        _dark: {
          _hover: {
            backgroundColor: rgba("white", 0.1),
            color: "white"
          },
          _selected: {
            backgroundColor: "black",
            color: "white"
          }
        }
      },
      tablist: {
        borderBottom: "unset",
        borderRadius: ".25rem",
        backgroundColor: "grayscale.50",
        _dark: {
          backgroundColor: "grayscale.700"
        }
      }
    },
    primary: {
      tab: {
        color: "blue.500",
        _hover: {
          backgroundColor: rgba(blue[500], 0.1)
        }
      }
    },
    soft: {
      tab: {
        color: "slate.800",
        _hover: {
          backgroundColor: "slate.50",
          color: "#444f58"
        },
        _dark: {
          color: "white",
          _hover: {
            backgroundColor: rgba(slate[100], 0.1)
          }
        }
      }
    }
  }
};

export { Tabs };
